import React, { CSSProperties } from 'react';

import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'redux/hooks';
import Dash from 'components/Icons/Dash';
import Broadcast from 'components/Icons/Broadcast';
import Chat from 'components/Icons/Chat';
import Book from 'components/Icons/Book';
import Grade from 'components/Icons/Grade';
import { getUser } from 'redux/authentication/auth.slice';

import BottomNavigationItem from './BottomNavigationItem';

import './BottomNavigation.scoped.scss';

interface Props {
  style?: CSSProperties;
}

const parentTabs = [
  {
    icon: <Dash />,
    name: 'common:Navigation_Drawer.Dash/Today',
    path: '/',
  },
  {
    icon: <Chat />,
    name: 'common:Navigation_Drawer.Chat',
    path: '/chat',
  },
  {
    icon: <Book />,
    name: 'common:Navigation_Drawer.Study',
    path: '/study',
  },
  {
    icon: <Grade />,
    name: 'common:Navigation_Drawer.Grades',
    path: '/grades',
  },
];

const navTabs = [
  {
    icon: <Dash />,
    name: 'common:Navigation_Drawer.Dash/Today',
    path: '/',
  },
  {
    icon: <Broadcast />,
    name: 'common:Navigation_Drawer.Live Classes',
    path: '/live',
  },
  {
    icon: <Chat />,
    name: 'common:Navigation_Drawer.Chat',
    path: '/chat',
  },
  {
    icon: <Book />,
    name: 'common:Navigation_Drawer.Study',
    path: '/study',
  },
];

const BottomNavigation: React.FC<Props> = () => {
  const user = useAppSelector(getUser);
  const { t } = useTranslation();

  const items = user.role !== 'parent' ? navTabs : parentTabs;

  return (
    <div className="bottom-navigation-container">
      {items.map(e => (
        <BottomNavigationItem icon={e.icon} name={t(e.name)} path={e.path} key={e.name} />
      ))}
    </div>
  );
};

export default BottomNavigation;
